import React from 'react';
export default function Register(props) {
return (
  <div>
  {props.isLoggedIn ? 
  <div>
    <h2>Register New Admin</h2>
    <form>
      <div>
        <label htmlFor="username">Username</label>
        <input type="text" id="username" onChange={props.handleUserForm} />
      </div>
      <div>
        <label htmlFor="password">Password</label>
        <input type="password" id="password" onChange={props.handleUserForm} />
      </div>
      <input value="Submit" className="submit" type="submit" onClick={props.register} />
    </form>
    
  </div> : <h1>Access Denied</h1>}</div>
);
}
